let elements = {
  // withoutCheck: true,
  mainImage: {
    imagePath: 'games/page004_game4/img/bcg.png',
    pos: {
      y: 0,
      x: 0,
    },
    width: 1920,
  },
  balloons: {
    quantity: 10,
    maxStartTime: 7,
    maxDuration: 20,
    directionFrom: 'bot',
    rotate: 'bot',
    scale: 1,
    form: 'balloon',
    //color: 'gray',
    // audio: {
    //   src: 'audio/test/laser.mp3',
    //   volume: 0.5,
    // },
  },
  // mbAudioItemData: [
  //   {
  //     src: require('./audio/audio.mp3'),
  //     audioConfig: {
  //       autoplay: true,
  //       loop: false,
  //       volume: 0.5,
  //     },
  //     iconConfig: {
  //       fill: 'black',
  //     },
  //     pos: {
  //       y: 0,
  //       x: 0,
  //     },
  //     width: '10vh',
  //     height: '10vh',
  //     unit: '%',
  //   },
  // ],
};

export default elements;
